import { Route } from '@angular/router';
import { SubscriptionsComponent } from './subscriptions.component';
import { AuthGuard } from '../../shared/services';
import { SubscriptionsListRoutes } from './subscriptions-list/subscriptions-list.routes';

export const SubscriptionsRoutes: Route[] = [
    {
      path: 'subscriptions',
      component: SubscriptionsComponent,
      canActivate: [AuthGuard],
      children: [
        ...SubscriptionsListRoutes
      ]
    }
  ];
